<template>
  <div class="tw-my-32">
    <h2 class="tw-text-6xl tw-font-bold tw-text-center tw-mb-32">Tell us about your event!</h2>

    <div class="md:tw-flex md:tw-justify-center">
      <div class="md:tw-w-1/3 lg:tw-w1/4 tw-mx-12 tw-mb-12">
        <label for="">
          Number of Anticipated Guests
        </label>
        <input
          type="number" 
          @change="setGuestCount"
          :value="props.guestCount"
          placeholder="Enter a number"
          class="tw-block tw-py-4 tw-w-full tw-font-bold tw-appearance-none focus:tw-outline-none tw-border-gray-400 focus:tw-border-orange-medium focus:tw-ring-0 tw-bg-transparent tw-text-2xl"
          min="0" step="1" 
          oninput="validity.valid||(value='');"
        />
      </div>
      <div class="md:tw-w-1/3 lg:tw-w1/4 tw-mx-12 tw-mb-12">
        <label for="">
         Event Type
        </label>
        <select 
          @change="setEventType"
          :value="props.eventType"
          class="tw-block tw-py-4 tw-w-full tw-font-bold tw-appearance-none focus:tw-outline-none tw-border-gray-400 focus:tw-border-orange-medium focus:tw-ring-0 tw-bg-transparent tw-text-2xl">
          <option value="" disabled>Select type</option>
          <option v-for="(t, index) in state.permittedTypes"
          :key="'evtType'+index.toString()" :value="t">{{t}}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { reactive } from 'vue';

  const emit = defineEmits(['guestCountSet','eventTypeSet']);

  const props = defineProps({
    guestCount: Number,
    eventType: String,
  });

  const state = reactive({
    guestCount: undefined as (undefined | Number),
    eventType: null,
    permittedTypes: [
      'Celebration & Social Event',
      'Corporate Meeting',
      'Sales & Networking',
      'Holiday & Community',
      'Wedding',
      'Other',
    ]
   })

  const setGuestCount = (event: Event) => {
    const target = event.target as HTMLSelectElement
    emit('guestCountSet', parseFloat(target.value));
  }

  const setEventType = (event: Event) => {
    const target = event.target as HTMLSelectElement
    emit('eventTypeSet', target.value);
  }

</script>
